export const billingYearLabel = year => `${year}/${Number(year) + 1}`;

export const BILLING_TYPES = ['PAYMENT', 'MONTHLY_CHARGE', 'ENROLLMENT_CHARGE', 'OPENING_BALANCE', 'CORRECTION', 'REFUND',
  'YEAR_TRANSFER_IN', 'YEAR_TRANSFER_OUT', 'YEAR_TRANSFER_REVERSAL'];

export function billingTypeLabel(type, tr) {
  return tr(`client:billing.types.${BILLING_TYPES.includes(type) ? type : 'OTHER'}`);
}

export function billingEntryDescription(entry, tr) {
  const year = Number(entry.schoolYearStartYear);
  if (entry.type === 'YEAR_TRANSFER_IN' && year) return tr('client:billing.transferFrom', { year: billingYearLabel(year - 1) });
  if (entry.type === 'YEAR_TRANSFER_OUT' && year) return tr('client:billing.transferTo', { year: billingYearLabel(year + 1) });
  if (entry.settlementMonth) return entry.settlementMonth.split('-').reverse().join('.');
  return '';
}

export function billingYears(ledger) {
  const years = ledger && ledger.summary && ledger.summary.years;
  return Array.isArray(years) ? [...years].sort((a, b) => b.schoolYearStartYear - a.schoolYearStartYear) : [];
}

export function billingHistory(entries, year, month = '', type = '') {
  return entries.filter(entry => String(entry.schoolYearStartYear) === String(year) &&
    (!month || String(entry.date).slice(0, 7) === month) && (!type || entry.type === type))
    .sort((a, b) => String(b.date).localeCompare(String(a.date)) || String(a.id).localeCompare(String(b.id)));
}

export function billingTotals(entries) {
  return entries.reduce((totals, entry) => {
    const amount = Number.isFinite(entry.amount) ? Math.round(entry.amount * 100) : 0;
    return {
      payments: totals.payments + (entry.type === 'PAYMENT' ? amount : 0),
      charges: totals.charges + (['MONTHLY_CHARGE', 'ENROLLMENT_CHARGE'].includes(entry.type) ? Math.abs(amount) : 0),
    };
  }, { payments: 0, charges: 0 });
}
